import { render, staticRenderFns } from "./UploadAssets.vue?vue&type=template&id=77db7d97&"
import script from "./UploadAssets.vue?vue&type=script&lang=js&"
export * from "./UploadAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports